"use strict";

import { useProjectMediaPlayback } from "./useProjectMediaPlayback";

export const useProjectAudioPlayback = useProjectMediaPlayback;
